import React from 'react'
import { AppScrollWrapperNew } from '../../../widgets/AppScrollWrapper/AppScrollWrapper'
import { useSearchParams } from 'react-router-dom'
import {
  IPlanMenuControlDimensionDto,
  IPlanMenuControlOrdersRequest,
} from '../../../core/api/dto/PlanMenuControlDto'
import { getTimeFromMins } from 'utils/formatDate'
import moment from 'moment'
import './FrozeList.css'

import { useCreateTaskObjectMutation } from 'core/api/TaskApi'
import {
  AppNotification,
  NotificationType,
} from 'components/notification/Notification'
import { useGetDimensionListByRole } from '../hooks/useGetDimensionListByRole'
import { useTranslation } from 'react-i18next'
import { AddItemButton } from 'shared/ui/AddItemButton/AddItemButton'
import { useParams } from 'react-router'

interface IFrozeListProps {
  pageParams?: IPlanMenuControlOrdersRequest | null
  withTaskAddButton?: boolean
}

export const FrozeList = ({
  pageParams,
  withTaskAddButton,
}: IFrozeListProps) => {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const { dishId } = useParams()
  const currentDishId = searchParams.get('dish')

  const {
    data: dimensionList,
    isError,
    isLoading,
  } = useGetDimensionListByRole(pageParams, currentDishId, dishId)

  const hasNoData =
    !!currentDishId &&
    (isError ||
      (!isLoading &&
        Array.isArray(dimensionList) &&
        dimensionList.length === 0))

  return (
    <div className="froze-list-wrap">
      <AppScrollWrapperNew theme="dropdown">
        {(!!currentDishId || dishId) &&
          Array.isArray(dimensionList) &&
          dimensionList.length > 0 &&
          [...dimensionList]
            .reverse()
            .map((item, index) => (
              <FrozeItem
                dimensionItem={item}
                index={index + 1}
                key={`${item.id}-fr-${index}`}
                withTaskAddButton={withTaskAddButton}
              />
            ))
            .reverse()}

        {hasNoData && <div>{t('Замеров по данному заказу нет')}</div>}
      </AppScrollWrapperNew>
    </div>
  )
}

interface IFrozeItemProps {
  dimensionItem: IPlanMenuControlDimensionDto
  index: number
  withTaskAddButton?: boolean
}

const FrozeItem = ({
  dimensionItem,
  index,
  withTaskAddButton,
}: IFrozeItemProps) => {
  const { t } = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams()
  const currentDimensionId = searchParams.get('dimension')?.split('_')[0] || 0
  const onDimensionHandler = () => {
    searchParams.set('dimension', `${dimensionItem.id}`)
    searchParams.set('index', `${index}`)
    setSearchParams(searchParams.toString(), { replace: true })
  }

  const [createTaskObject] = useCreateTaskObjectMutation()

  const onAddTaskObjectClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    createTaskObject({ orderLineDimension: dimensionItem.id })
      .unwrap()
      .then(() => {
        AppNotification({
          msg: 'Объект успешно добавлен',
          type: NotificationType.success,
        })
      })
  }

  return (
    <div
      className={`froze-item${
        dimensionItem.id === Number(currentDimensionId || 0) ? ' active' : ''
      }`}
      onClick={onDimensionHandler}
    >
      <div className="number">
        {dimensionItem.id === Number(currentDimensionId) &&
        withTaskAddButton ? (
          <AddItemButton onClick={onAddTaskObjectClick} />
        ) : (
          <span>{index}</span>
        )}
      </div>
      <div className="froze-info">
        <div className="froze">
          <span>{t('Замер')}</span>
          <div className="dotes" />
          <span>
            <b>{moment.parseZone(dimensionItem.dimensionDatetime).format('HH:mm')}</b>
          </span>
        </div>
        <div
          className={`realization${
            dimensionItem.implementationTimeExceeded ? ' error' : ''
          }`}
        >
          <span>{t('Реализация')}</span>
          <div className="dotes" />
          <span>
            <b>
              {!!dimensionItem.implementationTimeExceeded
                ? getTimeFromMins(dimensionItem.implementationTimeExceeded)
                : getTimeFromMins(dimensionItem.implementationTime)}
            </b>
          </span>
        </div>
      </div>
    </div>
  )
}
